module.exports = __webpack_public_path__ + "Lato-Bold.a9d8f02506c0ea8b1b0e.woff";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Bold.woff
// module id = ../../../../../src/assets/fonts/Lato/Lato-Bold.woff
// module chunks = styles